<template>
    <article class="preview-hint-container">
        <h3 style="margin-left: 10px">
            縮小圖卡
        </h3>
        <h4 style="font-size: 1rem; margin-left: 20px;">
            <v-icon left>
                mdi-cellphone
            </v-icon>
            手機版:
        </h4>
        <div 
            class="mini-card-container"
            ref="mini_card_ele"
        >
            <div class="mini-card"
                v-bind:style="{
                    width: '100%',
                    minHeight: '1em',
                    backgroundColor: marketing_card.mini_card_bg_color,
                    color: marketing_card.mini_card_color,
                    textAlign: marketing_card.mini_card_align,
                    cursor: 'pointer',
                    padding: '5px 0px',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    opacity: marketing_card.mini_card_opacity,
                }"
            >
                <div 
                    class="mini-card-text-container"
                >
                    {{marketing_card.mini_card_text}}
                </div>
                <Timer
                    :setting="mobile_mini_timer_setting"
                    :activate="this.oldSettingData!==null ? this.oldSettingData.is_countdown : marketing_card.is_auto_coupon"
                />				

            </div>

        </div>

        <h4 style="font-size: 1rem; margin-left: 20px;">
            <v-icon left>
                mdi-monitor
            </v-icon>
            桌機版:
        </h4>
        <div 
            class="mini-card-container"
            ref="desktop_mini_card_ele"
        >
            <div class="mini-card"
                v-bind:style="{
                    width: '100%',
                    minHeight: '1em',
                    backgroundColor: marketing_card.desktop_mini_card_bg_color,
                    color: marketing_card.desktop_mini_card_color,
                    textAlign: marketing_card.desktop_mini_card_align,
                    cursor: 'pointer',
                    padding: '5px 0px',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    opacity: marketing_card.desktop_mini_card_opacity,
                }"
            >	
                <div
                    class="mini-card-text-container"
                >
                    {{marketing_card.desktop_mini_card_text}}
                </div>
                <Timer
                    :setting="desktop_mini_timer_setting"
                    :activate="this.oldSettingData!==null ? this.oldSettingData.is_countdown : marketing_card.is_auto_coupon"
                >
                </Timer>			
            </div>
        </div>

    </article>
</template>

<script>

// 倒數計時器
import Timer from './CardComponents/Timer.vue'

// 引入 mapState 函數，用於簡化 computed 屬性的設定
import { mapState, mapGetters } from 'vuex';

export default {
    props: {
        timeLineMode: String,
        loadOldSettingData: Boolean,
    },
    name: "MiniCard",
    components: {
        Timer
    },
    data() {
        return {
            /* 桌機縮小圖卡設定 */
            desktop_mini_card_text: '桌機縮小的行銷文字',
            desktop_mini_card_color:'#ffffff',
            desktop_mini_card_bg_color:'#ffb3be',
            desktop_mini_card_align: 'center',
            desktop_mini_card_opacity: '',      	

            /* 手機縮小圖卡設定 */
            mini_card_text: '手機縮小的行銷文字',
            mini_card_color:'#ffffff',
            mini_card_bg_color:'#ffb3be',
            mini_card_align: 'center',
            mini_card_opacity: '',

            /* 是否自動帶入優惠代碼 */
      	    // isAutoCoupon: this.is_auto_coupon,

            marketing_card_setting: null,

            parseKey: {
                "活動預熱" : 'warmUpCardSetting',
                "活動進行" : 'activityCardSetting',
                "活動結束" : 'endUpCardSetting'
            }

            // mini_card_ele: this.$refs.mini_card_ele.innerHTML
            
        }
    },
    mounted() {
        console.log("yo Mini Card",);
    },
    updated() {
        // console.log(this.$refs.mini_card_ele.innerHTML);
        // console.log(this.$refs.desktop_mini_card_ele.innerHTML);
    },
    computed: {
        mobile_mini_timer_setting() {
    		let setting = {
                "card_type": this.marketing_card.card_type,
    			"font_size": "14px",
    			"end_at": this.marketing_card.end_at ? this.$utils.parseDateFormat(this.marketing_card.end_at) : "",
    			"bg_color": 'transparent', 

    			"description": this.marketing_card.mobile_mini_card_count_down_text,
    			"description_color": this.marketing_card.mobile_mini_card_count_down_text_color,

    			"description_end": this.marketing_card.mobile_mini_card_count_down_text_end,
    			"description_end_color": this.marketing_card.mobile_mini_card_count_down_text_end_color,

    			"d_text": this.marketing_card.count_down_d_text,
    			"d_text_color": this.marketing_card.count_down_d_text_color,
    			"d_value_color": this.marketing_card.count_down_d_value_color,

    			"h_text": this.marketing_card.count_down_h_text,
    			"h_text_color": this.marketing_card.count_down_h_text_color,
    			"h_value_color": this.marketing_card.count_down_h_value_color,    			
    			"m_text": this.marketing_card.count_down_m_text,
    			"m_text_color": this.marketing_card.count_down_m_text_color,
    			"m_value_color": this.marketing_card.count_down_m_value_color,     			
    			"s_text": this.marketing_card.count_down_s_text,
    			"s_text_color": this.marketing_card.count_down_s_text_color,
    			"s_value_color": this.marketing_card.count_down_s_value_color, 
				"repeat_day": Number(this.marketing_card.repeat_day),
				"timer_off_text": this.marketing_card.timer_off_text,
				"timer_off_text_color": this.marketing_card.timer_off_text_color,
				"start_at": this.marketing_card.start_at ? this.$utils.parseDateFormat(this.marketing_card.start_at) : "",
				"campaign_start_at": this.marketing_card.campaign_start_at ? this.$utils.parseDateFormat(this.marketing_card.campaign_start_at) : "",
				"campaign_end_at": this.marketing_card.campaign_end_at ? this.$utils.parseDateFormat(this.marketing_card.campaign_end_at) : ""
    		}

    		return setting
    	},
        desktop_mini_timer_setting() {
    		let setting = {
                "card_type": this.marketing_card.card_type,
    			"font_size": "14px",
    			"end_at": this.marketing_card.end_at ? this.$utils.parseDateFormat(this.marketing_card.end_at) : "",
                "start_at": this.marketing_card.start_at ? this.$utils.parseDateFormat(this.marketing_card.start_at) : "",
				"campaign_start_at": this.marketing_card.campaign_start_at ? this.$utils.parseDateFormat(this.marketing_card.campaign_start_at) : "",
				"campaign_end_at": this.marketing_card.campaign_end_at ? this.$utils.parseDateFormat(this.marketing_card.campaign_end_at) : "",
    			"bg_color": 'transparent',

    			"description": this.marketing_card.desktop_mini_card_count_down_text,
    			"description_color": this.marketing_card.desktop_mini_card_count_down_text_color,

    			"description_end": this.marketing_card.desktop_mini_card_count_down_text_end,
    			"description_end_color": this.marketing_card.desktop_mini_card_count_down_text_end_color,

    			"d_text": this.marketing_card.count_down_d_text,
    			"d_text_color": this.marketing_card.count_down_d_text_color,
    			"d_value_color": this.marketing_card.count_down_d_value_color,

    			"h_text": this.marketing_card.count_down_h_text,
    			"h_text_color": this.marketing_card.count_down_h_text_color,
    			"h_value_color": this.marketing_card.count_down_h_value_color,    			
    			"m_text": this.marketing_card.count_down_m_text,
    			"m_text_color": this.marketing_card.count_down_m_text_color,
    			"m_value_color": this.marketing_card.count_down_m_value_color,     			
    			"s_text": this.marketing_card.count_down_s_text,
    			"s_text_color": this.marketing_card.count_down_s_text_color,
    			"s_value_color": this.marketing_card.count_down_s_value_color,  
				"repeat_day": Number(this.marketing_card.repeat_day),
				"timer_off_text": this.marketing_card.timer_off_text,
				"timer_off_text_color": this.marketing_card.timer_off_text_color,
				
    		}

    		return setting
    	},
        ...mapState( ['is_auto_coupon','marketing_card'] ),
        ...mapGetters(["selectedAdmin","selectedOrg","selectedMarketingCardContainer","oldSettingData",'warmUpCardSetting','activityCardSetting','endUpCardSetting'])


        // marketing_card() {
        //     this.emitInnerHTML()
        //     return this.marketing_card_setting
        // }
    },
    methods: {
        changeStatus: function(param_name,field_name, new_value){
            let tmp = JSON.parse(JSON.stringify(this.$store.getters.marketing_card)) 
            tmp[field_name] = new_value
            this.$store.commit(param_name, tmp)
            console.log('after_commit', this.$store.getters[param_name])
        },
        emitInnerHTML() {
            const miniCardInnerHTML = this.$refs.mini_card_ele.innerHTML;
            // console.log(miniCardInnerHTML);
            this.$emit('mini-card-innerhtml', miniCardInnerHTML);
            const desktopMiniCardInnerHTML = this.$refs.desktop_mini_card_ele.innerHTML
            this.$emit('desktop-mini-card-innerhtml', desktopMiniCardInnerHTML);
        },
    },
    
    watch: {
        marketing_card: {
            handler: function(newValue) {
                let that = this
                that.marketing_card_setting = newValue    
            },
            deep: true,
            immediate: true
        },
        'marketing_card.get_ele_innerHTML': {
            handler: function(newValue) {
                console.log('marketing_card.get_ele_innerHTML', this.marketing_card);
                console.log(newValue);
                if (newValue) {
                    // this.changeStatus('marketing_card','mini_card_ele', this.$refs.mini_card_ele.innerHTML)
                    this.$nextTick(() => {
                        this.emitInnerHTML()   
                    })
                }
                // let that = this
                // that.marketing_card_setting = newValue 
            },
            deep: true,
            immediate: true
        },
        'marketing_card.is_auto_coupon': {
            handler: function(newValue) {
                console.log('marketing_card.is_auto_coupon');
                console.log(newValue);
                if (newValue) {
                    // this.changeStatus('marketing_card','mini_card_ele', this.$refs.mini_card_ele.innerHTML)
                    this.$nextTick(() => {
                        this.emitInnerHTML()   
                    })
                }
                // let that = this
                // that.marketing_card_setting = newValue 
            },
            deep: true,
            immediate: true
        }

    }

}
</script>

<style scoped>
    .mini-card-container {
        display: flex;
        justify-content: center;
        align-items: center;
        /* padding: 1em 0px; */
    }
    .mini-card{
        width: 100%;
        max-width: 375px;
    }
    .preview-container {
        /* width: 60%; */
        max-width: 480px;
        margin-right: 1em;
        height: 100%;
    }
    .preview-hint-container > h4{
        display: flex;
        align-items: center;
        margin-top: 0.5em;
    }
    .preview-hint-container > h4 > v-icon {
        margin-right: 0.5em;
    }
    .mini-card-container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 1em 0px;
    }
</style>